'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatter = undefined;

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatter = exports.formatter = {
  MedSalePrice: function MedSalePrice() {
    if (this.MedSalePrice.toString().length > 6) {
      return (0, _numeral2.default)(this.MedSalePrice).format('($0.00a)').toUpperCase();
    } else return (0, _numeral2.default)(this.MedSalePrice).format('($0a)').toUpperCase();
  },
  AvgSalePricePerSqft: function AvgSalePricePerSqft() {
    return (0, _numeral2.default)(this.AvgSalePricePerSqft).format('$0,0').toUpperCase();
  },

  MedSalePricePerSqft: function MedSalePricePerSqft() {

    return (0, _numeral2.default)(this.MedSalePricePerSqft).format('($0,0)');
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/formatters.js
// module id = 212
// module chunks = 0